<template>
  <v-container fluid class="grey800 px-6 py-6">
    <div class="mb-8 text-center">
      <GameIcon
        game="caseBattles" width="72" class="mx-auto mb-3" contain
        :aspect-ratio="1"
      />
      <h5 class="text-h6 text-uppercase font-weight-bold primary500--text">
        Join Crate Battle
      </h5>
      <p v-if="chosenTeamId" class="mb-0 text-body-2 primary100--text">
        Confirm the team you want to join in this battle
      </p>
      <p v-else class="mb-0 text-body-2 primary100--text">
        Pick a team to join this battle
      </p>
    </div>

    <div v-if="!chosenTeamId && !teamId" class="text-center mt-6 mb-9">
      <h4 class="text-uppercase text-body-2 font-weight-semibold text--secondary mb-4">
        Pick a team
      </h4>
      <div class="teams d-flex justify-center px-2">
        <div v-for="team in game.teams" :key="team.id" class="team">
          <BattleListingPlayer
            v-for="slot in team.slots"
            :key="slot"
            :player="game.playersByTeam(team.id)[slot - 1]"
            :game="game"
            :color="team.color"
            class="mr-3"
            @join="onJoin(team.id)"
          />
          <span v-if="game.teams.length !== 4" class="vs text--secondary text-caption font-weight-bold mr-1 px-1">
            <span>vs</span>
          </span>
        </div>
      </div>
    </div>

    <div v-if="pickedTeam" class="d-flex justify-center align-center mb-8">
      <BattleListingPlayer
        :game="game" no-tooltip :player="user" :color="pickedTeam.color"
        class="mr-5"
      />

      <div class="mt-1">
        <h4 class="text-body-2 font-weight-bold lh-1">
          {{ game.title }}
        </h4>
        <p v-if="!game.isCommunism" class="mb-0 text-caption text-uppercase font-weight-bold" :style="{color: pickedTeam.color}">
          Team {{ teamId }}
        </p>
      </div>
    </div>


    <div v-if="teamId" class="text-center mt-6 mb-6">
      <v-btn
        color="green700 green200--text" tile
        class="px-5 font-weight-bold" large
        depressed :ripple="false"
        @click="onJoin(teamId)"
      >
        Confirm
        <scrap class="ml-2" :amount="game.joinPrice" />
      </v-btn>
    </div>

    <div v-if="hasWarning" class="d-flex justify-center mb-4">
      <v-checkbox
        v-model="hideWarning"
        color="primary500" :ripple="false"
        hide-details dense class="ma-0"
        label="Don't show warning again"
      />
    </div>


    <v-alert
      v-if="game.isCursed"
      color="primary700" dense tile
      class="text-center mb-0"
    >
      <fai fixed-width :icon="['fad', 'skull-crossbones']" class="primary100--text text-body-2 mr-1" />
      <span class="text-body-2 font-weight-semibold primary100--text">
        Cursed Battle
      </span>
    </v-alert>

    <v-alert
      v-if="game.isUneven"
      color="primary700" dense tile
      class="text-center mb-0 mt-2"
    >
      <fai fixed-width :icon="['fad', 'exclamation-triangle']" class="primary100--text text-body-2 mr-1" />
      <span class="text-body-2 font-weight-semibold primary100--text">
        Uneven Teams
      </span>
    </v-alert>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import BattleListingPlayer from '@/views/games/CaseBattles/components/BattleListingPlayer'
import OnboardingMixin from '@/mixins/onboarding'

export default {
  components: {
    BattleListingPlayer,
  },
  mixins: [OnboardingMixin],
  props: {
    close: {
      type: Function,
      required: true,
    },
    payload: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      teamId: null,
      hideWarning: false,
    }
  },
  computed: {
    ...mapGetters({
      user: 'user/session',
    }),
    game() {
      return this.payload.game
    },
    pickedTeam() {
      return this.game.teams.find(i => i.id === this.teamId)
    },
    chosenTeamId() {
      const payloadTeamId = this.payload.teamId

      if (payloadTeamId) return payloadTeamId

      if (this.game.isCommunism) {
        return 1
      }

      return null
    },
    hasWarning() {
      if (this.onboardingHasSeen('battle-join-warning')) return false

      return this.game.isUneven || this.game.isCursed
    },
  },
  created() {
    this.teamId = this.chosenTeamId
  },
  methods: {
    ...mapActions({
      joinBattle: 'games/case-battles/join',
    }),
    async onJoin(teamId = this.teamId) {
      if (this.loading) return
      this.loading = true

      if (this.hideWarning) {
        this.onboardingSetSeen('battle-join-warning')
      }

      try {
        await this.joinBattle({
          id: this.game.id,
          teamId,
        })

        this.$router.push({
          name: 'Crate Battle',
          params: { id: this.game.id },
        }).catch(() => {})

        this.$toast.success('Battle joined')
        this.close()
      } catch (error) {
        this.$toast.error(error.message)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.teams {
  .team {
    .vs {
      @include xs {
        display: none;
      }
    }

    &:last-of-type {
      .vs {
        display: none;
      }
    }
  }
}
</style>
